import React from "react";
import { App } from "../../components/app";
import { DashboardContextProvider } from "../../contexts/dashboard-context";
import { ImporterContextProvider } from "../../contexts/importer-context";
import { PreviewContextProvider } from "../../contexts/preview-context";

export const MainScreen = () => (
	<DashboardContextProvider>
		<ImporterContextProvider>
			<PreviewContextProvider>
				<App />
			</PreviewContextProvider>
		</ImporterContextProvider>
	</DashboardContextProvider>
);
MainScreen.displayName = "MainScreen";
